//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return {
      msg:{
        kefu:'',
        beian:'',
      }
    }
  },
  mounted() {
    this.getQQ()
  },
  methods:{
    getQQ(){
      let data = 'cmd=qq_select'
      this.$http.post('https://api.abeiyun.com/www/user.php', data).then(({data}) => {
        if(data.response == 200) {
          this.msg = data.msg
        }else {

        }
      })
    },
    listDown(idx,id){
      if(this.msgIndex == idx){
        this.msgIndex = 10000
      }else{
        this.msgIndex = idx
        let data = 'cmd=user_msg_show'+
          '&read_type=id' +
          '&id='+id
        this.$http.post('https://api.abeiyun.com/www/user.php', data).then(({data}) => {
          if(data.response == 200) {

          }else{
            this.$router.push('/login')
          }
        })
      }
    },
    pageNum(n, par) {
      if(par == 'up') {
        if(n > 1) {
          n = n - 1;
          this.page = n
          this.count = '4';
          this.getMessage();
        }
      } else if(par == 'down') {
        if(n < this.pager.count) {
          n = parseInt(n) + 1;
          this.page = n
          this.count = '4';
          this.getMessage();
        }
      }
    },
  }

}




// WEBPACK FOOTER //
// ./src/components/user/contact.vue